import angular from 'angular';

const services = angular.module('applicationModule.postsServices', []);


services.factory('Posts', ['PostsAPI', function (PostsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return PostsAPI.all(appId, params)
                .then(function (response) {
                    return response.data.posts;
                });
        },
        get: function (id, appId) {
            return PostsAPI.get(id, appId);
        },
        save: function (data, editMode) {
            return PostsAPI.store(data, editMode);
        },
        remove: function (id) {
            return PostsAPI.remove(id);
        },
        categories: function (appId, search) {
            return PostsAPI.categories(appId, search);
        }
    };
}]);

services.service('PostsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/post/';

    this.all = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id, {params: {application_id: appId}});
    };

    this.store = function (data, editMode) {
        if (editMode) {
            return $http.put(API_URL + data.id, data);
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.remove = function (id) {
        return $http.delete(API_URL + id);
    };

    this.categories = function (appId, search) {
        return $http.get(API_URL + 'autocomplete/' + appId + '/' + search);
    };

}]);

export default services;
